import React from "react";
import Edmundo from "../images/contenido/PREMIACION EDMUNDO4.jpg";
import Levano from "../images/contenido/STELLA MOHME, CESAR LEVANO 001.jpg";
import Navigation from "../components/Navigation";
import { Helmet } from "react-helmet";

const Trayectoria = () => {
  return (
    <section className="nosotros talleres">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Premio a la Trayectoria - Memoria 2014-2024 - Fundación Gustavo Mohme Llona</title>
        <meta
          property="og:title"
          content="Premio a la Trayectoria - Memoria 2014-2024 - Fundación Gustavo Mohme Llona"
        />
      </Helmet>
      <div id="gustavo-mohme-llona" className="bg-white">
        <div className="container d-flex header-page">
          <div className="column-0">
            <div className="pre-title">4.2</div>
            <h1 className="color-brown">Premio a la Trayectoria</h1>
          </div>
          <div className="column-0">
            <div className="cont-mohme-0">
              <img
                src={Edmundo}
                alt="Edmundo Cruz acompañado por directivos y periodistas cercanos."
                className="mohme-0 border-img"
              />
              <div className="legend">
                Edmundo Cruz acompañado por directivos y periodistas cercanos.
              </div>
              <div className="block-brown"></div>
            </div>
            <div className="block-brown-light"></div>
          </div>
        </div>
        <div className="container">
          <div className="container-text">
            <p>
              Una iniciativa para reconocer la excelencia y la ética en el
              ejercicio del periodismo, así como el trabajo de periodistas
              comprometidos con la defensa de la democracia.
            </p>
            <h5>4.2.1 RECONOCIMIENTO A EDMUNDO CRUZ (2015)</h5>
            <p>
              El destacado periodista de investigación recibió el 23 de abril de
              2015 el Premio Fundación Gustavo Mohme Llona a la Trayectoria
              Periodística, un reconocimiento a su ejemplar desempeño
              profesional, plasmado en investigaciones y reportajes cruciales
              para el develamiento de crímenes, actos de corrupción y, en esa
              medida, fundamentales para el fortalecimiento de nuestra
              democracia. Dicho reconocimiento se llevó a cabo en la Casa
              O'Higgins, en el Centro de Lima. A la premiación y homenaje
              acudieron amigos, discípulos, colegas.
            </p>

            <figure className="img-left img-m">
              <div className="block-brown-light"></div>
              <img src={Levano} alt="César Lévano" className="img-m" />
              <div className="legend">
                César Lévano sostiene su premio acompañado de la directora de la
                fundación, Stella Mohme Seminario.
              </div>
            </figure>
            <h5>4.2.2 RECONOCIMIENTO A CÉSAR LÉVANO (2018)</h5>
            <p>
              El homenaje se llevó a cabo el miércoles 25 de abril en el
              auditorio del Instituto Raúl Porras Barrenechea. Durante la
              ceremonia se reconoció el trabajo de más de 70 años como
              periodista, tiempo en el que realizó notables aportes al ejercicio
              del periodismo en el Perú, llegando a ser director de diversos
              medios, siempre con un profundo compromiso con la verdad y el
              ejercicio crítico de la profesión. En la ceremonia tuvo una
              intervención especial el periodista y escritor Víctor Hurtado
              Oviedo, entrañable amigo de Lévano.
            </p>
            <div className="clear"></div>
          </div>
          <Navigation
              prev="https://fundacionmohme.org/especiales/memoria-2024/tribunal-constitucional"
              textPrev="4.1 Participación ciudadana en el proceso de selección de magistrados del Tribunal Constitucional"
              next="https://fundacionmohme.org/especiales/memoria-2024/#agradecimientos"
              textNext="Agradecimientos"
            />
        </div>
        
      </div>
    </section>
  );
};

export default Trayectoria;
